export enum SourceType {
  Filter = "Filter",
  File = "File",
  Odbc = "Odbc"
}
